import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, ChevronRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './LegalPage.css';

export default function LegalPage({ type }) {
  const { lang } = useLang();
  const t = translations[lang][type]; // 'privacy' or 'terms'
  const [activeSection, setActiveSection] = useState(0);

  const legalEmail = type === 'privacy' ? 'info@CoreNexFlow.com' : 'info@CoreNexFlow.com';

  return (
    <div className="legal-page">
      {/* Hero */}
      <section className="legal-hero">
        <div className="legal-hero__orb" />
        <div className="container">
          <div className="legal-hero__icon">
            <Shield size={32} strokeWidth={1.5} />
          </div>
          <span className="section-tag">{t.tag}</span>
          <h1 className="legal-hero__title">{t.tag}</h1>
          <p className="legal-hero__updated">{t.lastUpdated}</p>
          <p className="legal-hero__intro">{t.intro}</p>
        </div>
      </section>

      {/* Content */}
      <section className="legal-content section">
        <div className="container legal-content__inner">

          {/* Sidebar TOC */}
          <nav className="legal-toc">
            <p className="legal-toc__label">
              {lang === 'ar' ? 'المحتويات' : 'Contents'}
            </p>
            {t.sections.map((sec, i) => (
              <a
                key={i}
                href={`#section-${i}`}
                className={`legal-toc__item ${activeSection === i ? 'legal-toc__item--active' : ''}`}
                onClick={() => setActiveSection(i)}
              >
                <ChevronRight size={14} className="legal-toc__arrow" />
                <span>{sec.title}</span>
              </a>
            ))}
          </nav>

          {/* Main Sections */}
          <div className="legal-body">
            {t.sections.map((sec, i) => (
              <div
                key={i}
                id={`section-${i}`}
                className="legal-section"
                onMouseEnter={() => setActiveSection(i)}
              >
                <h2 className="legal-section__title">{sec.title}</h2>
                <p className="legal-section__content">{sec.content}</p>
              </div>
            ))}

            {/* Contact box */}
            <div className="legal-contact">
              <div className="legal-contact__icon">
                <Mail size={22} />
              </div>
              <div>
                <h3>{t.contactTitle}</h3>
                <p>
                  {t.contactDesc}{' '}
                  <a href={`mailto:${legalEmail}`} className="legal-contact__email">
                    {legalEmail}
                  </a>
                </p>
              </div>
            </div>

            {/* Quick nav to other legal page */}
            <div className="legal-also">
              {type === 'privacy' ? (
                <Link to="/terms" className="legal-also__link">
                  {lang === 'ar' ? 'اقرأ أيضاً: شروط الخدمة' : 'Also read: Terms of Service'} →
                </Link>
              ) : (
                <Link to="/privacy" className="legal-also__link">
                  {lang === 'ar' ? 'اقرأ أيضاً: سياسة الخصوصية' : 'Also read: Privacy Policy'} →
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
